import { Appearance } from './appearanceTypes';
import button from '../../components/core/button/button.dark.module.scss';
import colors from '../../components/foundation/colors/_color.dark.tokens.scss';
import gradients from '../../components/foundation/colors/_gradient.dark.tokens.scss';
import typography from '../../components/foundation/typography/typography.dark.module.scss';
import tooltip from '../../components/core/tooltip/tooltip.dark.module.scss';

export const dark: Appearance = {
  button,
  colors,
  gradients,
  typography,
  tooltip,
};
